import { FilterFieldType, FilterFieldV2 } from '../models';

const ELEMENT_TO_FIELD_TYPE_MAP: Record<string, FilterFieldType> = {
  input: FilterFieldType.TEXT,
  'dynamic-list-single-select': FilterFieldType.SET_FILTER, // FilterFieldType.DROPDOWN,
  'dynamic-list-multiple-selects': FilterFieldType.SET_FILTER, // FilterFieldType.MULTI_SELECT,
  select: FilterFieldType.SET_FILTER, // FilterFieldType.DROPDOWN,
  'set': FilterFieldType.SET_FILTER,
  'tree-view': FilterFieldType.TREE_VIEW_FILTER,
  'date': FilterFieldType.DATE,
  'date-interval': FilterFieldType.DATE,
  number: FilterFieldType.NUMBER,
  'country-autocomplete': FilterFieldType.AUTOCOMPLETE,
  'timezone': FilterFieldType.TIMEZONE,
  'timezone-autocomplete': FilterFieldType.TIMEZONE,
};

export function mapElementToFieldType(elementType: string): FilterFieldType {
  return ELEMENT_TO_FIELD_TYPE_MAP[elementType] || FilterFieldType.TEXT;
}

export function isFieldOfTypeList(field: FilterFieldV2): boolean {
  return field?.fieldType === FilterFieldType.MULTI_SELECT
    || field?.fieldType === FilterFieldType.DROPDOWN
    || field?.fieldType === FilterFieldType.SET_FILTER
    || field?.fieldType === FilterFieldType.AUTOCOMPLETE
    || field?.fieldType === FilterFieldType.TREE_VIEW_FILTER
    || field?.fieldType === FilterFieldType.TIMEZONE;
}
